import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  FetchResourceSubscriptionAction,
  FetchResourceSubscriptionFailedAction,
  FetchResourceSubscriptionSuccessAction,
  UpdateResourceSubscriptionAction,
  UpdateResourceSubscriptionFailedAction,
  UpdateResourceSubscriptionSuccessAction,
  UserResourceSubscriptionActionTypes,
} from './user-subscribed-resources.actions';
import { UserSubscribedResourcesService } from './user-subscribed-resources.service';

@Injectable()
export class UserResourceSubscriptionEffects {
  fetchResourceSubscriptionState$: Observable<
    | FetchResourceSubscriptionSuccessAction
    | FetchResourceSubscriptionFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION),
      mergeMap((action: FetchResourceSubscriptionAction) => {
        const { userId, resourceId } = action.payload;
        return this.userSubscribedResourcesService
          .isInUserSubscribedResources(userId, resourceId)
          .pipe(
            map(
              isSubscribed =>
                new FetchResourceSubscriptionSuccessAction({
                  resourceId,
                  isSubscribed,
                }),
            ),
            catchError(error =>
              observableOf(
                new FetchResourceSubscriptionFailedAction({
                  error,
                  resourceId,
                }),
              ),
            ),
          );
      }),
    ),
  );

  addToUserSubscribedResources$: Observable<
    | UpdateResourceSubscriptionSuccessAction
    | UpdateResourceSubscriptionFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION),
      mergeMap((action: UpdateResourceSubscriptionAction) => {
        const { userId, resourceId } = action.payload;
        return this.userSubscribedResourcesService
          .addToUserSubscribedResources(userId, resourceId)
          .pipe(
            map(
              isSubscribed =>
                new UpdateResourceSubscriptionSuccessAction({
                  resourceId,
                  isSubscribed,
                }),
            ),
            catchError(error =>
              observableOf(
                new UpdateResourceSubscriptionFailedAction({
                  error,
                  resourceId,
                }),
              ),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private userSubscribedResourcesService: UserSubscribedResourcesService,
  ) {}
}
